import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceService } from './invoice.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [InvoiceService],
  exports: [],
})
export class InvoiceModule {}
